import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cat_image",
  "use": "icon-cat_image-usage",
  "viewBox": "0 0 11.47 10.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.47 10.3\" id=\"icon-cat_image\"><title>Image</title><g id=\"icon-cat_image_图层_2\" data-name=\"图层 2\"><g id=\"icon-cat_image_图层_1-2\" data-name=\"图层 1\"><path d=\"M3.4,2.33A1.07,1.07,0,1,0,4.47,3.4,1.07,1.07,0,0,0,3.4,2.33Z\" /><path d=\"M0,.48V9.82a.48.48,0,0,0,.48.48H11a.49.49,0,0,0,.48-.48V.48A.48.48,0,0,0,11,0H.48A.49.49,0,0,0,0,.48ZM10.5,9.33h-8L6.9,4.91l3.6,3.6ZM1,1H10.5V7.14L6.9,3.54,1,9.47Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol